import {
  AccountResourceControlPolicies,
  useGetResourceControlPoliciesQuery,
  useResourceControlPolicySubscription,
} from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

export function ResourceControlPolicyEventsSubscription() {
  const accountId = useActiveAccountId();

  useGetResourceControlPoliciesQuery({
    variables: { accountId },
    skip: !accountId,
  });

  useResourceControlPolicySubscription({
    variables: { accountId },
    skip: !accountId,
    onData: ({ client: { cache }, data: { data: result } }) => {
      cache.updateFragment(
        {
          id: cache.identify({ __typename: 'Account', id: accountId }),
          fragment: AccountResourceControlPolicies,
          fragmentName: 'AccountResourceControlPolicies',
        },
        (previousData) => ({
          ...previousData,
          resourceControlPolicies: {
            ...result.resourceControlPolicy.resourceControlPolicies,
          },
        })
      );
    },
  });

  return null;
}
